import { maxLength, required, TextInput } from "react-admin";
import { useField } from "react-final-form";

const UniqueCodeInput = () => {
  const {
    input: { onChange, value },
  } = useField("uniqueCode");
  console.log(value);

  return (
    <TextInput
      label="Last 3 Digits Of Nric/Fin/Passport + Alphabet E.G. (123a)"
      source="uniqueCode"
      validate={[required(), maxLength(4)]}
      onChange={(e: any) => {
        const string: string = e.target.value;
        onChange(string.toUpperCase());
      }}
    />
  );
};

export default UniqueCodeInput;
